import Service from '@ember/service';
import type { Chart, ChartConfiguration } from 'chart.js';

export default class ChartService extends Service {
  #Chart!: typeof Chart;

  public async createChart(
    element: HTMLCanvasElement,
    config: ChartConfiguration,
  ): Promise<Chart> {
    await this.#registerChart();

    const existingChart = this.#Chart.getChart(element);
    if (existingChart) {
      existingChart.destroy();
    }

    return new this.#Chart(element, config);
  }

  public destroyChart(chart: Chart): void {
    chart.destroy();
  }

  async #registerChart(): Promise<void> {
    if (this.#Chart) {
      return;
    }

    const ChartModule = await import('chart.js');

    const {
      Chart,
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      LineController,
      Tooltip,
      Legend,
      BarElement,
      BarController,
    } = ChartModule;

    Chart.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      LineController,
      Tooltip,
      Legend,
      BarElement,
      BarController,
    );

    this.#Chart = Chart;
  }
}

declare module '@ember/service' {
  interface Registry {
    chart: ChartService;
  }
}
